import gql from 'graphql-tag'

export const getIbStatus = gql`
  subscription DooerComGetIbStatus($sessionId: ID!) {
    ibSessionStatusV2(sessionId: $sessionId) {
      ... on IbSessionStatusUpdate {
        institution
        status
        bankIdQRImage
        autoStartToken
      }
      ... on IbSessionMessage {
        institution
        message
      }
    }
  }
`
